export const WalkthroughManager = {
  findTarget(selector?: string): HTMLElement | null {
    if (!selector) return null;
    try {
      return document.querySelector<HTMLElement>(selector);
    } catch {
      return null;
    }
  },

  async waitForTarget(selector?: string, timeout = 3000) {
    if (!selector) return null;
    const started = Date.now();
    while (Date.now() - started < timeout) {
      const target = this.findTarget(selector);
      if (target) return target;
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }
    return null;
  },
};
